import { MediaPlayer } from "dashjs";
import { useState } from "react";
import { MediaPlayerContext } from "./media-player-context";

type MediaPlayerProviderProps = {
  children: React.ReactNode;
};

export function MediaPlayerProvider({ children }: MediaPlayerProviderProps) {
  const [mediaPlayer] = useState(() => MediaPlayer().create());

  return (
    <MediaPlayerContext.Provider value={mediaPlayer}>
      {children}
    </MediaPlayerContext.Provider>
  );
}
